import { render, staticRenderFns } from "./EmrDataEdit.vue?vue&type=template&id=3829172a&scoped=true&"
import script from "./EmrDataEdit.vue?vue&type=script&lang=js&"
export * from "./EmrDataEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmrDataEdit.vue?vue&type=style&index=0&id=3829172a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3829172a",
  null
  
)

export default component.exports